// extracted by mini-css-extract-plugin
export default {"form":"form__-2be123bd","row":"row__-2be123bd","buttonGroup":"buttonGroup__-2be123bd","btn":"btn__-2be123bd","save":"save__-2be123bd","cancel":"cancel__-2be123bd"};